"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var carTitleStyles_1 = require("./carTitleStyles");
var Translation_1 = require("../../../../common/components/presentation/Translation/Translation");
var CarTitle = function (_a) {
    var shouldRenderTitleInfo = _a.shouldRenderTitleInfo, modelTitle = _a.modelTitle, variantTitle = _a.variantTitle;
    var style = carTitleStyles_1.default();
    return (<>
      {shouldRenderTitleInfo && (<core_1.Typography variant="subtitle1" data-test="summary:vehicle:car_title_description" className={style.title}>
          <Translation_1.default id={'carDetails.label.carDetails'}/>
        </core_1.Typography>)}
      <core_1.Typography variant="subtitle1" className={style.titleWrapper} data-test="summary:vehicle:car_title">
        <core_1.Typography variant="subtitle1" component="span" className={style.carMake} data-test="summary:vehicle:car_title_model">
          {modelTitle}
        </core_1.Typography>
        <core_1.Typography component="span" className={style.titleWrapper} data-test="summary:vehicle:car_title_variant">
          {variantTitle}
        </core_1.Typography>
      </core_1.Typography>
    </>);
};
exports.default = CarTitle;
